export const PROMO_CODE_SESSION_STORAGE_KEY = 'promoCode'

export function normalizePromoCode(code: string): string {
  return code.replace(/[^0-9a-zA-Z]/g, '')
}
